module.exports = __webpack_public_path__ + "img/数据监控背景light.8911e2db.png";